export default "__VITE_ASSET__b1681f6b__"